module.exports = __webpack_public_path__ + "static/media/santa-fe-stucco.eb3bfc14.bmp";